import React, { Component, createRef } from 'react';
import Validator from 'validatorjs';
import QueryString from 'query-string';
import ReCAPTCHA from 'react-google-recaptcha';
import { Redirect, Link } from 'react-router-dom';
import { Form, Row, Col, Image } from 'react-bootstrap';

import './Auth.css';

import { Http } from '../../support';
import { Auth } from '../../support';
import ByPactopia from './ByPactopia';
import { FormControl } from '../../facturotopia';
import LoadingButton from '../../facturotopia/LoadingButton';
import ResponseError from '../../shared/responses/ResponseError';

class AuthPasswordReset extends Component {

  state = {};

  recaptchaRef = null;

  constructor(props) {
    super(props);

    const query = QueryString.parse(this.props.location.search);

    const email = query.email;

    this.state = {
      data: {},
      busy: false,
      restored: false,
      isLoggedIn: false,
      validator: new Validator({}, this.getRules({})),
      email: email,
    };

    this.recaptchaRef = createRef();
  }

  componentDidMount = async () => {
    this.setState({
      busy: true
    });

    try {
      const { search = '' } = this.props.location || {};

      const query = QueryString.parse(this.props.location.search);

      const headers = {
        'X-Tenancy': query.tenancy
      }

      await Http.post(`auth/password/reset/credentials/${search}`, {}, { headers });

      this.setState({
        busy: false,
        verify: true
      });
    } catch (error) {
      this.setState({
        error: error.data || error,
        busy: false,
        verify: false,
      });
    }
  }

  getRules(data) {
    return {
      password: ['required', 'confirmed', 'min:8', 'password'],
      password_confirmation: ['required', 'min:8', 'password'],
    }
  }

  validate(data) {
    const validator = new Validator(data, this.getRules(data));

    validator.check();

    this.setState({
      validator
    });

    return validator;
  }

  handleOnChange = (value) => {
    const data = {
      ...this.state.data,
      ...value
    }

    const validator = this.validate(data);

    this.setState({
      data,
      isValid: validator.passes()
    });
  }

  handleOnSubmit = async () => {
    this.setState({
      busy: true,
      error: null
    });

    try {
      const challenge = await this.recaptchaRef.current.executeAsync();

      const query = QueryString.parse(this.props.location.search);

      const params = {
        ...this.state.data,
        challenge: challenge,
        token: query.token,
        email: query.email
      }

      const headers = {
        'X-Tenancy': query.tenancy
      }

      const response = await Http.post('/auth/password/reset', params, { headers });

      const { access_token, cliente, empresa, ...rest } = response;

      const user = {
        ...rest,
        empresa: undefined,
        cliente: undefined,
        emisor: undefined,
      };

      const data = {
        tenancy: query.tenancy,
        token: { access_token },
        user,
        empresa: empresa || {},
        emisor: {},
        cliente: cliente || {},
      };

      await Auth.setData(data);

      this.setState({
        isLoggedIn: true,
        busy: false
      });
    } catch (error) {
      this.setState({
        error: error.data || error,
        busy: false
      });
    }
  }

  renderError = () => {
    const { error } = this.state;

    return (
      <div className="result-container">
        <ResponseError
          title="Error"
          variant="inline"
          error={ error }
          onAction={ this.handleOnAction }
        />
      </div>
    );
  }

  onCaptchaChange = (value) => {
    const { data } = this.state;

    this.setState({
      data: {
        ...data,
        challenge: value
      }
    });
  }

  render() {
    const {
      data,
      isValid,
      busy,
      error,
      verify,
      validator,
      isLoggedIn,
    } = this.state;

    if (isLoggedIn) {
      let { from } = this.props.location.state || { from: { pathname: '/app/dashboard' } };

      if (from.pathname === '/auth/login') {
        from.pathname = '/app/dashboard';
      }

      return <Redirect to="/bridge" state={ from } />;
    }

    return (
      <Form autoComplete="off">

        <div className="auth-content">
          <div className="avatar mt-4">
            <div className="auth-logo">
                <div className="d-flex justify-content-start">
                    <Image src="/img/logo.png"
                      className="auth-logo-img opacity-6"
                      fluid={ true }
                    />
                    <p className="title text-muted">Facturotöpia</p>
                </div>
              </div>
          </div>

          <div className="login-content">
            <div className="pb-3">
              <h6 className="text-muted">
                Resetear Contraseña
              </h6>
            </div>

            { !!verify && (
              <div className="form-box">
                <FormControl type="password"
                  label="Contraseña"
                  name="password"
                  help="Por seguridad, la contraseña debe contener una mayúscula, un número y un caracter especial ($%&#.?¡@/)"
                  autoFocus={ true }
                  validator={ validator }
                  value={ data.password }
                  onChange={ this.handleOnChange }
                />

                <FormControl type="password"
                  name="password_confirmation"
                  label="Confirmar Contraseña"
                  validator={ validator }
                  value={ data.password_confirmation }
                  onChange={ this.handleOnChange }
                />

                <ReCAPTCHA
                  size="invisible"
                  ref={ this.recaptchaRef }
                  sitekey={ process.env.REACT_APP_RECAPTCHA_KEY }
                  onChange={ this.onCaptchaChange }
                />

                <Row>
                  <Col className="text-right">
                    <LoadingButton type="button"
                      block={ true }
                      loading={ busy }
                      disabled={ !isValid || busy }
                      onClick={ this.handleOnSubmit }
                    >
                      { busy && 'Solicitando...'}
                      { !busy && 'Cambiar contraseña' }
                    </LoadingButton>
                  </Col>
                </Row>

                <div className="pt-3">
                  { !!error && this.renderError() }
                </div>

                <Row>
                  <Col className="text-center">
                    <Link to='/auth/login'>
                      Iniciar sesión
                    </Link>
                  </Col>
                </Row>
              </div>
            )}
          </div>

          { !verify && (
            <>
              <p className="text-muted">
                El link para registrar su nueva contraseña ha expirado, le pedimos iniciar el proceso nuevamente o contacte a su proveedor.
              </p>
              <Col className="text-center">
                  <Link to="/auth/password/email">
                    Reestablecer Contraseña
                  </Link>
              </Col>
            </>
          )}

          <Row className="pt-4 pb-3">
            <Col>
              <small className="text-muted">
                Al continuar aceptas nuestros <a href="/">Términos del servicio</a> y nuestro <a href="/">Acuerdo de privacidad</a>
              </small>
            </Col>
          </Row>

          <ByPactopia />

        </div>
      </Form>
      )
    }
  }

  export default AuthPasswordReset;